import React from "react";
import { FlexCol } from "../components/generic/Containers";
import { LandingPagedHeader } from "../components/landingPage/LandingPageHeader";
import { BlogMainMenu } from "../components/DashboardMainMenus";
import { Footer } from "../components/Footer";
import { useNavigate } from "react-router-dom";

export const BlogPublicPage: React.FC = () => {
    const navigate = useNavigate();

    const handleBlogClick = (blogNavUrl: string, contentType: string) => {
        navigate(`/blog-public/${blogNavUrl}`);
    };

    return (
        <FlexCol widthPercent={100}>
            <LandingPagedHeader isEducator={false} />
            <FlexCol padding={2} gap={2} maxWidth={80} alignSelf="center" widthPercent={100}>
                <BlogMainMenu setSelectedContent={handleBlogClick} />
            </FlexCol>
            <Footer />
        </FlexCol>
    );
};
